<template>
    <div>
    <v-container v-bind:class="{ isAdmin: showForAdminInSettings }" class="go-back-btn-sect add-prods-page-back-btn-sect">
        <v-btn
                v-if="!show"
                slot="activator"
                color="transparent"
                class="go-back-btn"
                @click="clear"
                :ripple="false"
        >
            <v-icon class="ex-back-icon">icon-arrow-347</v-icon>
            <span>{{ formTitle }}</span>
        </v-btn>
    </v-container>
    <v-layout class="products-add-main" align-center justify-center column >
        <v-container v-if="showForAdminInSettings" class="ex-title the-main-concept" v-bind:class="{ isAdmin: showForAdminInSettings }">
            {{ $t('products.all_goods')}}
        </v-container>
        <v-container v-else-if="show" class="ex-title the-main-concept">
          <h1> {{ $t('my_goods')}}</h1>
        </v-container>
        <v-container v-else class="ex-title the-main-concept">
          <h2> {{ $t('products.add_product')}}</h2>
        </v-container>
    <v-layout align-center justify-center column class="the-main-concept">
    <div class="ex-add-product">
        <span v-if="status.status" :style="{color: status.color}">{{$t('products.' + status.status)}}</span>
        <v-form ref="form" v-model="valid" lazy-validation class="ex-add-product-page">
            <v-layout row wrap v-if="userData && !show">
                <v-flex xs12 offset-md1 md5 class="p-0-25">
                    <v-flex class="ex-flat-field">
                        <label class="ex-flat-label">{{$t('products.product_name')}}</label>
                        <v-text-field
                                flat
                                id="product-name"
                                v-model="productData.title"
                                :rules="titleRules"
                        />
                    </v-flex>
                    <v-flex  class="ex-flat-field location-sect">
                        <label class="ex-flat-label">{{$t('products.location')}}</label>
                        <v-combobox
                                v-model="productData.address"
                                @keydown="keydownSearchAddress"
                                @keyup="keyupSearchAddress"
                                @input="selectSuggestedAddress"
                                class="search-individual-input"
                                :items="productData.addressSuggestions"
                                item-text="label"
                                item-value="locationId"
                                :loading="productData.addressSuggestionLoading"
                                :placeholder="$t('products.select_location')"
                                clearable
                                prepend-inner-icon="icon-location"
                                append-icon=""
                                attach=".location-sect"
                        >
                            <template slot="no-data">
                                <v-list-tile-content class="no-data-available" v-text="$t('no_data_available')"/>
                            </template>

                            <template
                                    slot="item"
                                    slot-scope="{ item }"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title
                                            v-html="item.label"
                                            style="width: 325px"
                                    />
                                </v-list-tile-content>
                            </template>
                        </v-combobox>
                    </v-flex>
                    <v-flex class="category-select">
                        <label class="ex-flat-label">{{$t('products.categories')}}</label>
                        <v-select
                                class="ex-flat-field"
                                :items="categories"
                                name="CategoryTranslations[0].name"
                                v-model="productData.category"
                                :placeholder="$t('products.select_category')"
                                :rules="categoryRules"
                                item-disabled="hasSubCategory"
                                item-text="CategoryTranslations[0].name"
                                item-value="id"
                                append-icon="icon-angle-down-18"
                                attach=".category-select"
                        >
                            <template slot="item" slot-scope="data">
                                <template v-if="data.item.header === ''">
                                    <v-list-tile-content v-text="data.item.CategoryTranslations[0].name"/>
                                </template>
                                <template v-else>
                                    <v-list-tile-avatar>
                                    </v-list-tile-avatar>
                                    <v-list-tile-title v-html="data.item.CategoryTranslations[0].name"/>
                                </template>
                            </template>
                        </v-select>
                    </v-flex>
                  <br/>
                    <v-flex v-if="false" class="ex-radio-button"> <!-- TODO if need status option delete if condition-->
                        <label class="ex-flat-label">{{$t('products.status')}}</label>
                        <v-radio-group v-model="productData.status" >
                            <v-radio
                                    class="ex-radio-button"
                                    :label="$t('products.give')"
                                    :value="true"
                                    color="blue"
                                    readonly
                                    dark
                                    :ripple="false"
                            >
                            </v-radio>
                            <v-radio
                                    class="ex-radio-button"
                                    :label="$t('products.need')"
                                    :value="false"
                                    color="blue"
                                    dark
                                    :ripple="false"
                            />
                        </v-radio-group>
                    </v-flex>
                    <v-flex class="ex-radio-button">
                        <label class="ex-flat-label">{{$t('products.state')}}</label>
                        <v-radio-group v-model="productData.state">
                            <v-radio
                                    class="ex-radio-button"
                                    :label="$t('products.all')"
                                    :value="0"
                                    selected
                                    @change="closeSelectedAria"
                                    color="blue"
                                    dark
                                    :ripple="false"
                            />
                            <v-radio
                                    class="ex-radio-button"
                                    :label="$t('products.selected')"
                                    @change="openSelectedAria"
                                    :value="true"
                                    color="blue"
                                    dark
                                    :ripple="false"
                            />
                            <v-icon>icon-information</v-icon>
                        </v-radio-group>
                    </v-flex>
                    <v-flex v-if="openSelected">
                      <div class="d-flex row justify-space-between  group-choose align-center">
                        <v-flex class="checkbox-sect">
                          <label class="g-checkbox">
                            <input :value="false" type="checkbox" v-model="onlyFriends">
                            <span class="g-label">{{$t('products.friends')}}</span>
                            <span class="checkmark"></span>
                          </label>
                        </v-flex>
                        <v-flex>
                          <v-layout class="ex-flat-field groups-choose-sect">
                            <div class="group-choose-label">
                              <label class="ex-flat-label">{{$t('group.select_group')}}</label>
                            </div>
                            <div class="search-other-categories">
                              <v-combobox
                                :items="groups"
                                :placeholder="$t('group.select_groups')"
                                append-icon="icon-plus-big"
                                class="ex-scroll"
                                item-text="name"
                                item-value="name"
                                multiple
                                small-chips
                                solo
                                hide-selected
                                v-model="groupsModel"
                              >
                                <template
                                  slot="selection"
                                  slot-scope="{ item, parent, selected }"
                                  v-if="item === Object(item)"
                                >
                                  <v-chip
                                    :selected="selected"
                                    label
                                    small
                                  >
                                    <span class="pr-2 main-span">
                                      {{ item.name }}
                                    </span>
                                    <v-icon
                                      @click="parent.selectItem(item)"
                                      small
                                    >close
                                    </v-icon>
                                  </v-chip>
                                </template>
                                <div slot="no-data">
                                  <v-list-tile-content class="groups-available-heading"
                                                       v-text="$t('group.no_groups_in_list')"/>
                                </div>
                                <template
                                  slot="item"
                                  slot-scope="{ item }"
                                >
                                  <v-list-tile-content>
                                    <v-list-tile-title
                                      v-html="item.name"
                                    />
                                  </v-list-tile-content>
                                </template>
                              </v-combobox>
                            </div>
                          </v-layout>
                        </v-flex>
                      </div>
                    </v-flex>
                </v-flex>
                <v-flex xs12 md5 class="p-0-25">
                    <v-flex class="relative mb-25">
                        <label class="ex-flat-label">{{$t('products.images')}}</label>
                        <div v-if="productData.imageUrl" class="d-flex justify-space-between align-center">
                            <div class="productImg" v-if="productData.imageUrl">
                                <img :src="productData.imageUrl" height="150"
                                     :alt="$t('products.image')"/>
                            </div>
                            <div class="productImg" v-else>
                                <img src="../../assets/images/NoImage.png" :alt="$t('products.image')">
                            </div>
                            <vue-dropzone class="ex-abs-dropzone"
                                          v-if="productData.imageUrl"
                                          v-bind:class="{ clickable: isClickable  }"
                                          ref="productImagesDropzone"
                                          id="dropzoneAbs"
                                          :options="dropzoneOptions"
                                          :useCustomSlot=true
                                          @vdropzone-file-added="vueFileAdded"
                                          @vdropzone-success="productFileSuccess"
                                          @vdropzone-removed-file="productRemovedFile"
                                          @vdropzone-error="productFileError"
                            >
                                <div class="dz-message" data-dz-message>
                                    <v-icon class="f-s-20">icon-plus-big</v-icon>
                                </div>
                            </vue-dropzone>
                        </div>
                        <div class="subImages ">
                            <div v-for="prImage of productData.images" :key="prImage.key" class="preview-product-images">
                                <div @click="selectImageAsGeneral(prImage)" class="replace-image">{{$t('products.select_as_main')}}</div>
                                <v-icon color="pink" @click="removeProductImage(prImage)">icon-cancel</v-icon>
                                <img :src="prImage.dataURL" :alt="$t('products.image')" @click="selectImageAsGeneral(prImage)" :class="prImage.isActive === true ? 'need-pointer active': 'need-pointer'">
                            </div>
                        </div>
                        <vue-dropzone :options="dropzoneOptions"
                                      :useCustomSlot=true
                                      @vdropzone-error="productFileError"
                                      @vdropzone-file-added="vueFileAdded"
                                      @vdropzone-removed-file="productRemovedFile"
                                      @vdropzone-success="productFileSuccess"
                                      class="ex-rel-dropzone"
                                      id="dropzoneRel"
                                      ref="productImagesDropzone"
                                      v-bind:class="{ clickable: isClickable  }"
                                      v-if="!productData.imageUrl"
                        >
                          <div class="dropzone-custom-content relative" v-if="!isClickable">
                            <div class="d-flex justify-center mb-25">
                              <img src="../../assets/images/image-icon.svg" alt="" style="width: 58px">
                            </div>
                            <h3 class="dropzone-custom-title">{{$t('products.drag_and_drop_images')}}</h3>
                            <div class="subtitle">...{{$t('products.or_click_select_file')}}</div>
                          </div>
                        </vue-dropzone>
                    </v-flex>
                    <v-flex  class="ex-flat-field mb-20">
                        <label class="ex-flat-label">{{$t('products.description')}}</label>
                        <v-textarea

                                flat
                                v-model="productData.description"
                                :rules="productDescRules"
                                :placeholder="$t('products.description-for-1000')"
                                :counter="1000"
                                name="productData.description"
                                no-resize
                                height="142px"
                                rows="6"
                                class="description-field"
                        >
                        </v-textarea>
                    </v-flex>
<!--                    <v-flex>-->
<!--                        <div class="m&#45;&#45;10">-->
<!--                            <label class="ex-flat-label">{{$t('products.quantity')}}</label>-->
<!--                        </div>-->
<!--                        <v-flex  class="ex-number-field">-->
<!--                            <v-text-field-->
<!--                                    v-model="productData.quantity"-->
<!--                                    type="number"-->
<!--                                    min="1"-->
<!--                                    flat-->
<!--                                    readonly-->
<!--                                    disabled-->
<!--                                    append-outer-icon="icon-plus-big"-->
<!--                                    @click:append-outer="increment"-->
<!--                                    prepend-icon="remove"-->
<!--                                    @click:prepend="decrement"-->
<!--                                    :rules="quantityRules"-->
<!--                                    class="number-input-field"-->
<!--                            ></v-text-field>-->
<!--                        </v-flex>-->
<!--                    </v-flex>-->
                </v-flex>
                <!--Group-->
                <v-flex xs12 class="text-xs-right save-cancel-btn-sect">
                    <v-btn
                            class="g-btn-default g-btn-165 m-0-5 cancel-btn"
                            @click="clear"
                    >{{$t('products.cancel')}}</v-btn>
                    <v-btn
                            class="g-btn-main-light g-btn-165 m-0-5 ex-add-btn"
                            @click="saveProduct"
                           :disabled="loading"
                    >
                        {{$t('products.save')}}
                        <v-progress-circular
                        v-if="loading"
                        size="20"
                        indeterminate
                        color="primary"
                        />
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('products.delete_product')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-flex>
                        <p class="p-14">{{$t('products.delete_product_text')}}</p>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="g-btn-default g-btn-135 m-0-5" @click.native="closeModal">{{$t('products.cancel')}}</v-btn>
                    <v-btn class="g-btn-main-light g-btn-135 m-0-5" @click.native="deleteProduct">{{$t('products.delete')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog max-width="550px" v-model="rejectDialog">
          <v-form ref="rejectForm" class="disable-form-contact" lazy-validation v-model="validReject">
            <v-card>
              <v-card-title>
                <span class="headline">{{$t('products.decline')}}</span>
              </v-card-title>
              <v-card-text>
                <v-flex>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <v-textarea
                          :counter="150"
                          :no-resize="true"
                          :placeholder="$t('settings.description')"
                          :rules="noteRules"
                          class="modal-text-field ex-input-group"
                          name="note"
                          outline
                          v-model="note"
                        >
                        </v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="g-btn-default g-btn-135 m-0-5" @click.native="closeModal">{{$t('products.cancel')}}</v-btn>
                <v-btn class="g-btn-main-light g-btn-135 m-0-5" @click.native="sendNote">{{$t('products.send')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog
            v-model="productImgSrc"
            max-width="500px"
            v-if="productImgSrc"
            persistent
          >
            <v-card>
              <v-card-text>
                <vue-cropper
                  ref="cropperProductImage"
                  :src="productImgSrc"
                  :alt="$t('products.image')"
                  dragMode="move"
                  :aspectRatio="3 / 2"
                  :autoCropArea="0"
                  :movable="false"
                  :rotatable="false"
                  :scalable="false"
                  :zoomable="false"
                >

                </vue-cropper>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="g-btn-default g-btn-135 m-0-5" flat @click="cancelCropProductImage">{{$t('products.cancel')}}</v-btn>
                <v-btn class="g-btn-main-light g-btn-135 m-0-5" @click="cropProductImage">{{$t('products.crop_image')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        <template v-if="show">
            <v-layout column :class="showForAdminInSettings ? '' : 'ex-my-goods'">
                <div class="d-flex input-btn-sect">
                  <v-select v-if="roles.includes('admin') && showForAdminInSettings"
                            :items=productStatus
                            item-text="value"
                            item-value="key"
                            v-model="visibleType"
                  ></v-select>
                    <v-text-field
                            v-model="search"
                            append-icon="icon-magnifying-glass"
                            :placeholder="$t('products.search')"
                            single-line
                            hide-details
                            class="search-field"
                            flat solo
                    />
                    <v-btn
                            v-if="!showForAdminInSettings"
                            slot="activator"
                            color="primary"
                            class="mb-2 g-btn-main-light g-middle-btn ex-add-product-btn"
                            @click="clear"
                            :ripple="false"
                    >
                        {{$t('products.add_product')}}
                        <v-icon class="m-l-20 f-s-18">icon-plus-big</v-icon>
                    </v-btn>
                </div>
                <div class="scrolling-tab">
                    <v-data-table ref="productTable"
                            :class="showForAdminInSettings ? 'ex-product-table' : 'ex-product-table-users'"
                            :headers="headers"
                            :items="filteredProducts"
                            :search="search"
                            :pagination.sync="pagination"
                            sort-icon="icon-angle-down-18"
                    >
                        <template
                                slot="items"
                                slot-scope="props"
                        >
                            <td class="text-xs-center image-td">
                                <img class="tableImg" v-if="props.item.image" :src="apiUrl + props.item.image" alt="image"/>
                                <span v-else>{{$t('products.no_image')}}</span>
                            </td>
                            <td class="text-xs-left">
                                <v-chip v-if="showForAdminInSettings">
                                    <v-tooltip top>
                                        <v-avatar @click="$router.push('/accounts/' + props.item.User.id)" slot="activator" dark color="primary">
                                            <img :src="apiUrl + props.item.User.image" alt="user">
                                        </v-avatar>
                                        <span>{{ props.item.User.firstName + ' ' + (props.item.User.lastName || '') }}</span>
                                    </v-tooltip>
                                    {{ props.item.ProductTranslations[0].name }}
                                </v-chip>
                              <div v-if="props.item.approved === 2">
                                <v-tooltip top>
                                  <p slot="activator" class="mb-0">{{ props.item.ProductTranslations[0].name }}</p>
                                  <span style="display: block; width: 200px">{{props.item.options.note}}</span>
                                </v-tooltip>
                              </div>
                              <p v-else class="mb-0">{{ props.item.ProductTranslations[0].name }}</p>
                            </td>
                          <td class="text-xs-left">
                            <div v-if="props.item.approved === 2">
                              <v-tooltip top>
                                <span v-if="props.item.Category && props.item.Category.status === 1" slot="activator" class="mb-0">{{ props.item.Category.CategoryTranslations[0].name }}</span>
                                 <span slot="activator" class="text-xs-left" v-else>{{$t('others')}}</span>
                                <span style="display: block; width: 200px">{{props.item.options.note}}</span>
                              </v-tooltip>
                            </div>
                            <div v-else>
                          <span class="text-xs-left" v-if="props.item.Category && props.item.Category.status === 1">
                            {{ props.item.Category.CategoryTranslations[0].name }}
                          </span>
                          <span class="text-xs-left" v-else>{{ $t('others') }}</span>
                          </div>
                          </td>
                          <td class="text-xs-center">
                            <div v-if="props.item.approved === 2">
                              <v-tooltip top>
                                <span slot="activator" class="mb-0">{{ props.item.ProductTranslations[0].quantity }}</span>
                                <span style="display: block; width: 200px">{{props.item.options.note}}</span>
                              </v-tooltip>
                            </div>
                            <div v-else>
                              <span class="text-xs-center">{{ props.item.ProductTranslations[0].quantity }}</span>
                            </div>
                          </td>
                          <td class="text-xs-center">
                            <div v-if="props.item.approved === 2">
                              <v-tooltip top>
                                <span slot="activator" class="mb-0">{{ props.item.ProductTranslations[0].description.length > 75 ? props.item.ProductTranslations[0].description.substring(0, 225) + '...' : props.item.ProductTranslations[0].description  }}</span>
                                <span style="display: block; width: 200px">{{props.item.options.note}}</span>
                              </v-tooltip>
                            </div>
                            <div v-else>
                              <span class="text-xs-center">{{ props.item.ProductTranslations[0].description.length > 75 ? props.item.ProductTranslations[0].description.substring(0, 225) + '...' : props.item.ProductTranslations[0].description  }}</span>
                            </div>
                          </td>
                          <td class="text-xs-center">
                            <div v-if="props.item.approved === 2">
                              <v-tooltip top>
                                <span slot="activator" class="mb-0"> {{ props.item.state ===0 ? $t('products.all')  : props.item.state ===1 ? $t('products.friends') : props.item.state ===2 ? $t('products.groups') : $t('products.friends_groups') }}</span>
                                <span style="display: block; width: 200px">{{props.item.options.note}}</span>
                              </v-tooltip>
                            </div>
                            <div v-else>
                              <span class="text-xs-center"> {{ props.item.state ===0 ? $t('products.all')  : props.item.state ===1 ? $t('products.friends') : props.item.state ===2 ? $t('products.groups') : $t('products.friends_groups') }}</span>
                            </div>
                          </td>
                          <td class="text-xs-left">
                            <div v-if="props.item.approved === 2">
                              <v-tooltip top>
                                  <span slot="activator" style="color: green"
                                        v-if="props.item.userId === loggedUser.id && props.item.accepted">
                                  {{ $t('products.given') }}</span>
                                <span slot="activator" style="color: #5a65db"
                                      v-else-if="(props.item.userId === loggedUser.id || showForAdminInSettings) && !props.item.accepted">{{
                                    $t('products.pending')
                                  }}</span>
                                <span style="color: gray" v-else>{{ $t('products.taken') }}</span>
                                <span style="display: block; width: 200px">{{ props.item.options.note }}</span>
                              </v-tooltip>
                            </div>
                            <div v-else>
                          <span style="color: green" v-if="props.item.userId === loggedUser.id && props.item.accepted">
                                  {{ $t('products.given') }}</span>
                              <span style="color: #5a65db"
                                    v-else-if="(props.item.userId === loggedUser.id || showForAdminInSettings) && !props.item.accepted">{{
                                  $t('products.pending')
                                }}</span>
                              <span style="color: gray" v-else>{{ $t('products.taken') }}</span>
                            </div>
                          </td>
                          <td class="text-xs-center">
                                <div class="d-flex justify-space-around layout" v-if="props.item.approved === 0">
                                    <span  v-bind:style="props.item.User.status=== 2 ? 'color:  orange;' : '#5a65db'">{{$t('products.waiting')}}</span>
                                </div>
                                <div v-if="props.item.approved === 1">
                                    <span style="color: green" >{{$t('products.approved')}}</span>
                                </div>
                                <div v-else-if="props.item.approved === 2">
                                  <v-tooltip top>
                                    <span style="color: red" slot="activator">{{$t('products.rejected')}}</span>
                                    <span style="display: block; width: 200px">{{props.item.options.note || $t('products.rejected')}}</span>
                                  </v-tooltip>
                                </div>
                              <div v-else-if="roles.includes('admin') && showForAdminInSettings && props.item.User.status === 2 && props.item.approved === 3">
                                    <span style="color: orange" >{{$t('products.product_for_blocked_user')}}</span>
                                </div>
                            </td>
                            <td class="text-xs-center">
                                <a v-if="props.item.ProductRequests" href="" @click = "$router.push('/products/' + props.item.id + '/' + props.item.ProductTranslations[0].name.replace(/\s+/g, '-'))">{{ props.item.ProductRequests.length}}</a>
                            </td>
                            <td v-if="(props.item.userId === loggedUser.id || showForAdminInSettings) && !props.item.accepted" class="action-icons-sect">
                                <div class="d-flex justify-space-around layout">
                                    <v-icon @click="editItem(props.item)" class="ex-edit-icon">icon-edit-profile</v-icon>
                                    <v-icon @click="deleteModal(props.item)" class="ex-delete-icon">icon-delete</v-icon>
                                    <v-icon v-if="roles.includes('admin')" @click="approveProduct(props.item, 1)" color="green">check_circle</v-icon>
                                    <v-icon v-if="roles.includes('admin')" @click="rejectProduct(props.item)" color="red">block</v-icon>
                                  <v-btn class="reset" v-if="props.item.userId === loggedUser.id"
                                         color="blue"
                                         @click="getProdRequests(props.item.id)"
                                  >{{$t('products.request')}}
                                  </v-btn>
                                </div>
                            </td>
                          <td class="eye-icon-sect " v-else>
                            <div class="d-flex justify-space-between align-center layout">
                              <v-btn  class="m-0 eye-icon" icon  @click = "$router.push('/products/' + props.item.id + '/' + props.item.ProductTranslations[0].name.replace(/\s+/g, '-'))" :ripple="false">
                                <v-icon>icon-view-1</v-icon>
                              </v-btn>
                              <v-btn class="reset" v-if="props.item.userId === loggedUser.id"
                                     color="blue"
                                     @click="reset(props.item.id)"
                              >{{$t('products.reset')}}
                              </v-btn>
                              <v-btn class="reset" v-if="props.item.userId === loggedUser.id && (props.item.copied === 0 || props.item.copied === 2)"
                                     color="blue"
                                     @click="placeAnother(props.item.id)"
                              >{{$t('products.place_another')}}
                              </v-btn>
                              <v-btn class="reset" v-if="props.item.userId === loggedUser.id"
                                     color="blue"
                                     @click="getProdRequests(props.item.id)"
                              >{{$t('products.request')}}
                              </v-btn>
                            </div>
                          </td>

                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Your search for "{{ search }}" found no results.
                        </v-alert>
                    </v-data-table>
                </div>
            </v-layout>
        </template>
    </div>
    </v-layout>
    </v-layout>
      <v-dialog max-width="800px" v-model="dialogRequests">
        <v-form class="disable-form-contact" lazy-validation ref="form" v-model="valid">
          <v-card-title
            class="justify-center ex-card-title">
            <v-layout class="g-cancel-btn">
              <v-btn
                :ripple="false"
                @click.native="closeModal"
                class="ex-v-btn ex-close-btn">
                <i class="icon-cancel"></i>
              </v-btn>
            </v-layout>
            <p class="g-modal">{{ $t('product_requests') }}</p>
          </v-card-title>
          <div v-if="requestData.length > 0">
          <template v-for="(item) in requestData">
          <v-list-tile class="note-list-product-req"
                       :key="item.id"
                       avatar
          >
            <v-layout row  justify-center class="notification-sect">
              <v-flex lg4 sm6 d-flex align-center class="custom1">
                <router-link :to="/accounts/ + item.User.id">
                  <v-list-tile-avatar class="avatars-container" size="45">
                    <img v-if="item.User && item.User.image"
                         :src="apiUrl + item.User.image"
                         :alt="$t('avatar')">
                    <img v-else src="../../assets/images/NoImage.png" :alt="$t('avatar')">
                  </v-list-tile-avatar>
                </router-link>
                <div class="user-content">
                  <router-link :to="`/accounts/${item.User.id}`"
                               v-html="item.User.firstName + ' ' +  (item.User.lastName || '') + ' ' +  '<br>' + item.User.email + '<br>' + item.User.phoneNumber"
                               class="user-info"/>
                </div>
              </v-flex>
              <v-flex lg4 sm6  class="custom2">
                <div>
                    <v-list-tile-sub-title class="note-content"
                    >
                      <p class="note-message">
                        {{item.message}}</p>
                    </v-list-tile-sub-title>
                </div>
              </v-flex>
              <v-flex class="custom3 mb-4" lg4 sm12>
                <div class="buttons" v-if="item.accepted === null">
                  <v-list-tile-action>
                    <v-btn class="decline-btn" :ripple="false" @click="rejectRequest(item.id, false)">
                      {{$t('products.decline')}}
                      <img src="../../assets/images/reject.svg" alt="reject">
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-action>
                    <v-btn class="accept-btn" :ripple="false" @click="confirmRequest(item.id)">
                      {{$t('products.accept')}}
                      <img src="../../assets/images/confirm.svg" alt="confirm">
                    </v-btn>
                  </v-list-tile-action>
                </div>
                <div class="buttons" v-else-if="item.accepted === true">
                  <v-layout align-center justify-space-between class="request-message">
                    <img  src="../../assets/images/accept.svg" alt="accept">
                    <v-list-tile-title class="request-message-info">
                      {{$t('products.requestAccepted')}}
                    </v-list-tile-title>
                  </v-layout>
                </div>
                <div class="buttons" v-else>
                  <v-layout align-center justify-space-between class="request-message">
                    <img src="../../assets/images/combined-shape.svg" alt="">
                    <v-list-tile-title class="request-message-info">
                      {{$t('products.requestRejected')}}
                    </v-list-tile-title>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-list-tile>
          </template>
          </div>
          <div v-else class="text-center"> {{$t('products.not_request')}}</div>
        </v-form>
      </v-dialog>
      <v-dialog v-model="dialogConfirm" max-width="550px">
        <v-form ref="formConfirm" v-model="validConfirm" lazy-validation class="disable-form-contact">
          <v-card class="contact-with-user-modal">
            <v-card-title class="modal-close-btn-sect">
              <v-btn
                class="cancel-user-contact-modal-btn"
                :ripple="false"
                flat
                @click.native="close">
                <v-icon>icon-cancel</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title class="text-md-center headline-title title-name">
              <span>{{$t('profile.contact_me')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-xs>
                <v-layout wrap class="chose-contact-type-sect">
                  <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                    <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                      <v-checkbox v-model="enabledTel"
                                  :label="$t('profile.contact_by_phone')"
                                  color="#8890e4"
                                  class="shrink mr-2"/>
                      <v-text-field
                        :disabled="!enabledTel"
                        v-model="contactByTel"
                        :rules="contactByTelRules"
                        color="indigo"
                        class="shrink mr-2 type-input"
                        flat-rigth
                        solo
                        placeholder="+374XXXXXXXX"
                      />
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                    <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                      <v-checkbox
                        v-model="enabledEmail"
                        :label="$t('profile.contact_by_email')"
                        color="#8890e4"
                        class="shrink mr-2"/>
                      <v-text-field
                        :disabled="!enabledEmail"
                        v-model="contactByEmail"
                        :rules="contactByEmailRules"
                        color="indigo"
                        class="shrink mr-2 type-input"
                        flat-rigth
                        solo
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions class="modal-btn-sect">
              <v-spacer></v-spacer>
              <v-btn class="cancel-request-btn2" :ripple="false" @click.native="close">{{$t('products.cancel')}}</v-btn>
              <v-btn class="send-request-btn" :ripple="false" @click.native="save" :disabled="!enabledTel && !enabledEmail">{{$t('products.send')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { EventBus } from '../../event-bus'
import {changeImageSize, validateTitle, last, validateEmail} from '../../helpers/main'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VueCropper from 'vue-cropperjs'
import VueJwtDecode from 'vue-jwt-decode'

function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}

export default {
  name: 'MyProducts',
  props: ['currentProduct'],
  components: {
    vueDropzone: vue2Dropzone,
    VueCropper: VueCropper
  },
  data: () => ({
    validConfirm: true,
    enabledTel: false,
    contactByTel: '',
    enabledEmail: true,
    contactByEmail: '',
    dialogConfirm: false,
    requestData: {},
    dialogRequests: false,
    visibleType: null,
    showAnother: true,
    data: '',
    status: {
      color: '',
      status: null
    },
    onlyFriends: null,
    isClickable: false,
    productImgSrc: null,
    productUploadedFile: {},
    productUploadTimer: {},
    show: true,
    showForAdminInSettings: false,
    valid: true,
    dialog: false,
    validReject: true,
    rejectDialog: false,
    note: null,
    rejectItem: {},
    loading: false,
    search: '',
    userData: {},
    products: [],
    editedIndex: -1,
    deleteItem: {},
    fileMaxSizeRules: [],
    defaultItem: {
      category: null,
      title: '',
      quantity: 1,
      description: '',
      imageName: '',
      image: '',
      imageUrl: '',
      imageFile: '',
      state: 0,
      status: true,
      images: [],
      addressSuggestionLoading: false,
      address: '',
      addressData: {},
      addressSuggestions: []
    },
    productData: {
      category: null,
      title: '',
      quantity: 1,
      description: '',
      imageName: '',
      image: '',
      imageUrl: '',
      imageFile: '',
      state: 0,
      status: true,
      images: [],
      addressSuggestionLoading: false,
      address: '',
      addressData: {},
      addressSuggestions: [],
      groupId: null
    },
    categories: [],
    groupsModel: [],
    apiUrl: process.env.ROOT_API,
    group: {
      typingTimer: {},
      addNewOneGroup: false,
      description: '',
      name: ''
    },
    groups: [],
    openSelected: false,
    groupNames: [],
    groupDataId: [],
    pagination: {
      sortBy: 'ProductTranslations[0].name'
    }
  }),
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      stateUserData: state => state.auth.userData,
      loggedUser: state => state.auth.userData
    }),
    filteredProducts () {
      return this.products.filter((i) => {
        return this.visibleType === null || (i.approved === this.visibleType)
      })
    },
    productStatus () {
      return [
        { key: null, value: this.$t('settings.all_products') },
        { key: 0, value: this.$t('settings.pending') },
        { key: 1, value: this.$t('settings.approved') },
        { key: 2, value: this.$t('settings.rejected') },
        { key: 3, value: this.$t('settings.deactivated') }
      ]
    },
    formTitle () {
      return this.show ? this.$t('products.add_product') : this.$t('products.back_to_product_list')
    },
    titleRules () {
      return [
        v => (!!v && v.trim() !== '') || this.$t('products.product_title_required'),
        v => validateTitle(v) || this.$t('products.title_not_valid')
      ]
    },
    nameRules () {
      return [v => (!!v && v.trim() !== '') || this.$t('group.group_name_required')
      ]
    },
    noteRules () {
      return [v => (!!v && v.trim() !== '') || this.$t('products.note')
      ]
    },
    quantityRules () {
      return [
        v => !!v || this.$t('products.product_quantity_required'),
        v => v > 0 || this.$t('products.product_wrong_quantity')
      ]
    },
    categoryRules () {
      return [
        v => !!v || this.$t('products.product_category_required')
      ]
    },
    productDescRules () {
      return [
        v => v.length <= 1000 || this.$t('products.product_desc_valid')
      ]
    },
    requestMessageRules () {
      return [
        v => (!!v && v.trim() !== '') || this.$t('products.request_message_required'),
        v => (v.length <= 150 && v.length > 50) || this.$t('products.request_desc_valid')
      ]
    },
    contactByTelRules () {
      const rules = []
      if (this.enabledTel) {
        rules.push(v => !!v || this.$t('profile.phone_required'))
        rules.push(v => (!!v && /^\+?(?:[0-9] ?){6,14}[0-9]$/.test(v)) || this.$t('profile.phone_not_valid'))
      }
      return rules
    },
    contactByEmailRules () {
      const rules = []
      if (this.enabledEmail) {
        rules.push(v => !!v || this.$t('email_required'))
        rules.push(v => validateEmail(v) || this.$t('email_not_valid'))
      }
      return rules
    },
    headers () {
      return [
        { text: this.$t('products.image'), value: 'image', sortable: false },
        {
          text: this.$t('products.products'),
          align: 'left',
          sortable: true,
          value: 'ProductTranslations[0].name'
        },
        { text: this.$t('products.category'), value: 'Category.CategoryTranslations[0].name' },
        { text: this.$t('products.qty'), value: 'ProductTranslations[0].quantity' },
        { text: this.$t('products.description'), value: 'ProductTranslations[0].description' },
        { text: this.$t('products.state'), value: 'state' },
        { text: this.$t('products.status'), value: 'status' },
        { text: this.$t('products.review'), value: 'approved' },

        { text: this.$t('products.request_count'), value: 'ProductRequests.length', sortable: true },
        { text: this.$t('products.action'), value: 'title', sortable: false }
      ]
    },
    dropzoneOptions () {
      return {
        url: process.env.ROOT_API + '/api/postDropzoneImage',
        thumbnailWidth: 130,
        maxFilesize: 8,
        maxFiles: 1,
        timeout: 60000,
        addRemoveLinks: true,
        resizeWidth: 1200,
        acceptedFiles: 'image/*',
        dictRemoveFile: 'X'
      }
    }
  },
  created () {
    if (this.currentProduct) {
      this.editItem(this.currentProduct)
    }
    if (this.$route.name === 'ProfileSettings' && this.roles.includes('admin')) {
      this.showForAdminInSettings = true
      this.pagination.sortBy = 'approved'
    }
    EventBus.$on('language-changed', this.languageChanged)
    this.initialize()
  },
  watch: {
    dialogConfirm (val) {
      val || this.close()
      this.$refs.formConfirm.resetValidation()
    },
    dialog (val) {
      val || this.closeModal()
    },
    rejectDialog (val) {
      val || this.closeModal()
    },
    groupsModel (val, prev) {
      if (val.length === prev.length) return
      this.groupsModel = val.map(v => {
        if (typeof v === 'string' && v.trim() !== '') {
          this.$store.dispatch('groups/add', {name: v, image: []})
            .then(response => {
              this.groups.push({id: response.group.id, name: response.group.displayData.name, description: response.group.displayData.description})
            })
            .catch(err => {
              console.log(err)
            })
          v = {
            name: v
          }
        }
        return v
      })
    }
  },
  mounted () {
    this.$refs.productTable.$el.querySelector('.v-table__overflow').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.productTable.$el.querySelector('.v-table__overflow').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
    // Detect when scrolled to bottom.
    this.$nextTick(e => {
      const listElm = document.querySelector('.v-autocomplete__content')
      if (listElm) {
        listElm.addEventListener('scroll', e => {
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
            this.getAllGroups()
          }
        })
      }
    })
  },
  methods: {
    close () {
      this.dialogConfirm = false
      setTimeout(() => {
        this.productId = null
      }, 300)
    },
    rejectRequest (id, accept) {
      this.acceptRequest(id, accept)
    },
    confirmRequest (id) {
      if (this.loggedUser) {
        this.contactByTel = this.loggedUser.phoneNumber
        this.contactByEmail = this.loggedUser.email
      }
      this.productId = id
      this.dialogConfirm = true
    },
    acceptRequest (id, accept) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true
      let data = {}
      data.id = id
      data.accept = accept
      if (this.enabledTel && this.contactByTel) {
        data.contactByTel = this.contactByTel
      }
      if (this.enabledEmail && this.contactByEmail) {
        data.contactByEmail = this.contactByEmail
      }
      this.$store.dispatch('products/acceptRequest', data).then((response) => {
        setTimeout(() => {
          this.isDisabled = false
        }, this.disabledTimeout)
        this.$toastr(response.type, response.message, this.$t(response.type))
        this.getProdRequests(id)
      }).catch(console.error)
    },
    save () {
      if (this.$refs.formConfirm.validate()) {
        this.acceptRequest(this.productId, true)
        this.close()
      }
    },
    initialize () {
      this.getUserProducts()
      this.getAllCategories()
      this.getAllGroups()
    },
    languageChanged () {
      this.initialize()
    },
    editItem (item) {
      if (item.userId === this.loggedUser.id && item.ProductRequests && item.ProductRequests.length > 0) {
        this.status = {
          color: 'green',
          status: 'given'
        }
      } else if (item.userId === this.loggedUser.id && item.ProductRequests && item.ProductRequests.length === 0) {
        this.status = {
          color: '#5a65db',
          status: 'pending'
        }
      }
      this.editedIndex = this.products.indexOf(item)
      let product = Object.assign({}, item)
      if (product.state !== 0) {
        this.productData.state = true
        this.openSelected = true
        if (product.state === 1) {
          this.onlyFriends = true
        } else if (product.state === 2) {
          product.ProductGroups.forEach(group => {
            let groupName = {
              name: group.Group.GroupTranslations[0].name,
              description: group.Group.GroupTranslations[0].description,
              id: group.id
            }
            this.groupsModel.push(groupName)
          })
        } else if (product.state === 3) {
          this.onlyFriends = true
          product.ProductGroups.forEach(group => {
            let groupName = {
              name: group.Group.GroupTranslations[0].name,
              description: group.Group.GroupTranslations[0].description,
              id: group.id
            }
            this.groupsModel.push(groupName)
          })
        }
      } else {
        this.productData.state = product.state
      }
      this.show = false
      this.productData.title = product.ProductTranslations[0].name
      this.productData.quantity = product.ProductTranslations[0].quantity
      this.productData.description = product.ProductTranslations[0].description
      this.productData.status = product.status
      this.productData.imageUrl = product.image ? this.apiUrl + product.image : null
      this.productData.category = product.Category && product.Category.id
      this.productData.id = product.id
      if (product.ProductAddresses[0]) {
        this.productData.addressData = product.ProductAddresses[0].Address
        this.productData.address = product.ProductAddresses[0].Address.label
        this.productData.addressSuggestions = [product.ProductAddresses[0].Address]
      }
      if (product.options && product.options.images && product.options.images.length > 0) {
        product.options.images.forEach(img => {
          img['dataURL'] = this.apiUrl + img['md']
          img['key'] = img['original']
          img['isActive'] = product.image !== null && product.image === img['sm']
        })
        this.productData.images = product.options.images
      }
    },
    deleteModal (item) {
      this.deleteItem = item
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
      this.rejectDialog = false
      this.dialogRequests = false
    },
    deleteProduct () {
      if (this.deleteItem) {
        this.dialog = false
        const index = this.products.indexOf(this.deleteItem)
        this.$store.dispatch('profile/deleteProduct', this.deleteItem.id).then((res) => {
          if (res.status) {
            this.products.splice(index, 1)
            this.$toastr(res.type, res.message, this.$t(res.type))
          }
        }).catch(console.error)
      }
    },
    sendNote () {
      if (this.$refs.rejectForm.validate() && this.rejectItem) {
        this.approveProduct(this.rejectItem, 2)
      } else {
        this.$toastr('error', this.$t('fill_required_fields'), this.$t('error'))
        return false
      }
    },
    getProdRequests (id) {
      this.dialogRequests = true
      let productId = {
        id
      }
      this.$store.dispatch('products/getProdRequests', productId).then((res) => {
        if (res) {
          this.requestData = res.productReq
          console.log(res.productReq)
        }
      }).catch(console.error)
    },
    reset (id) {
      let productId = {
        id
      }
      this.$store.dispatch('products/reset', productId).then((res) => {
        if (res) {
          this.$toastr(res.type, res.message, this.$t(res.type))
          this.getUserProducts()
        }
      }).catch(console.error)
    },
    placeAnother (id) {
      let productData = {
        userId: this.loggedUser.id,
        productId: id
      }
      this.$store.dispatch('products/placeAnother', productData).then((res) => {
        if (res) {
          this.$toastr(res.type, res.message, this.$t(res.type))
          this.getUserProducts()
        }
      }).catch(console.error)
    },
    saveProduct () {
      if (this.productData.state === true && this.groupsModel.length === 0 && !this.onlyFriends) {
        this.$toastr('error', this.$t('select'), this.$t('error'))
        return false
      }
      if (this.productData.state === 0) {
        this.groupsModel = []
        this.onlyFriends = false
      }
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.groupsModel.length > 0) {
          this.groupsModel.forEach(v => {
            if (!v.id) {
              let foundGroup = {}
              this.groups.find(group => {
                if (group.name === v.name) {
                  foundGroup = group
                }
              })
              this.groupsModel.splice(this.groupsModel.indexOf(v), 1, foundGroup)
            }
          })
          this.groupsModel.forEach(group => {
            this.groupDataId.push(group.id)
          })
        }
        if (this.groupsModel.length > 0 && this.onlyFriends) {
          this.productData.state = 3
        } else if (this.groupsModel.length > 0) {
          this.productData.state = 2
        } else if (this.onlyFriends) {
          this.productData.state = 1
        }
        let _uploadImages = []
        let _existImages = []
        let mainImage = {}
        if (this.productData.images.length > 0) {
          this.productData.images.forEach((img) => {
            if (img.croppedImage) {
              _uploadImages.push(img.croppedImage)
            } else {
              if (!img.isActive) {
                const _img = {...img}
                delete _img.dataURL
                delete _img.isActive
                delete _img.key
                _existImages.push(_img)
              } else {
                mainImage = {...img}
              }
            }
          })
          if (mainImage) {
            delete mainImage.dataURL
            delete mainImage.isActive
            delete mainImage.key
            _existImages.push(mainImage) // the last item is general image
          }
        } else {
          this.$toastr('error', this.$t('profile.image_not_valid'), this.$t('error'))
          this.loading = false
          return false
        }
        const data = {
          id: this.productData.id,
          category: this.productData.category,
          description: this.productData.description.trim(),
          image: this.productData.image,
          imageFile: this.productData.imageFile,
          imageUrl: this.productData.imageUrl,
          quantity: this.productData.quantity,
          state: this.productData.state,
          status: this.productData.status,
          title: this.productData.title.trim(),
          groupId: this.groupDataId,
          uploadImages: _uploadImages,
          images: _existImages,
          addressData: this.productData.address ? this.productData.addressData : {}
        }
        this.$store.dispatch('profile/saveProduct', data).then((res) => {
          if (res) {
            this.loading = false
            this.$toastr(res.type, res.message, this.$root.$t(res.type))
            this.clear()
            this.getUserProducts()
            this.onlyFriends = null
          }
        }).catch(console.error)
      } else {
        this.$toastr('error', this.$t('fill_required_fields'), this.$t('error'))
        return false
      }
    },
    getAllCategories () {
      this.$store.dispatch('profile/getAllCategories').then((res) => {
        this.categories = res.categories ? res.categories : []
        let catArr = []
        let subCatArr = []
        this.categories.forEach((cat) => {
          if (!cat.parentId) {
            cat.header = ''
            cat.hasSubCategory = false
            catArr.push(cat)
          } else {
            subCatArr.push(cat)
          }
        })

        let _categories = []
        catArr.forEach((cart) => {
          _categories.push(cart)
          subCatArr.forEach((subCart) => {
            if (cart.id === subCart.parentId) {
              if (last(_categories).hasSubCategory === false) {
                last(_categories).hasSubCategory = true
              }
              _categories.push(subCart)
            }
          })
        })
        this.categories = _categories
      }).catch(console.error)
    },
    getUserProducts () {
      if (this.showForAdminInSettings) {
        this.$store.dispatch('profile/getProductsForAdmin').then((res) => {
          this.prepareProducts(res.products)
        }).catch(console.error)
      } else {
        this.$store.dispatch('profile/getUserProducts').then((res) => {
          this.prepareProducts(res.products)
        }).catch(console.error)
      }
    },
    prepareProducts (products) {
      let _products = []
      products.forEach(product => {
        if (product.image !== null && product.image !== '') {
          product.image = changeImageSize(product.image, 'sm')
        }
        if (product.ProductRequests) {
          product.accepted = false
          product.ProductRequests.forEach(request => {
            if (request.accepted) {
              product.accepted = true
            }
          })
        }
        _products.push(product)
      })
      this.products = _products
    },
    approveProduct (item, approve) {
      const data = {
        id: item.id,
        approve: approve === 1,
        note: approve === 2 ? this.note : null
      }
      this.$store.dispatch('profile/approveProduct', data).then((res) => {
        this.$toastr(res.type, res.message, this.$root.$t(res.type))
        if (res.status) {
          item.approved = approve
        }
        this.rejectDialog = false
      }).catch(console.error)
    },
    rejectProduct (item) {
      this.rejectItem = item
      this.rejectDialog = true
    },
    getLocation () {
      let ipLocationCity = JSON.parse(localStorage.getItem('ipLocation')).city
      this.$store.dispatch('products/getAddressSuggestions', {address: ipLocationCity})
        .then((res) => {
          this.data = res.data.options.suggestions[0].label
          this.productData.address = this.data
          if (this.productData.address) {
            this.productData.addressData = res.data.options.suggestions[0]
          }
          this.productData.addressSuggestions = res.data.options && res.data.options && res.data.options.suggestions
          this.productData.addressSuggestionLoading = false
        })
        .catch((er) => {
          console.log(er.response)
        })
    },
    clear () {
      this.status = {
        color: '',
        status: null
      }
      this.show = !this.show
      this.editedIndex = -1
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
      this.defaultItem.images = []
      this.productData = Object.assign({}, this.defaultItem)
      this.groupDataId = []
      this.groupsModel = []
      this.openSelected = false
      this.getLocation()
    },
    productFileSuccess (file, response) {
      clearTimeout(this.productUploadTimer)
      this.productUploadedFile = file
      const reader = new FileReader()
      reader.onload = (event) => {
        // event.target.result contains base64 encoded image
        setTimeout(() => {
          this.productImgSrc = event.target.result
        }, 1000)
      }
      reader.readAsDataURL(file)
    },
    vueFileAdded (file) {
      this.isClickable = true
      this.productUploadTimer = setTimeout(() => {
        this.productFileError(file, this.$t('products.image_upload_max_time'))
      }, 60000)
    },
    productRemovedFile (file, error, xhr) {
      clearTimeout(this.productUploadTimer)
      this.destroyCropProductImage()
    },
    productFileError (file, error, xhr) {
      if (file.status === 'canceled') {
        return
      }
      if (file.status === 'error') {
        error = this.$t('products.image_upload_max_size')
      }
      this.destroyCropProductImage()
      this.$refs.productImagesDropzone.removeFile(file)
      this.$toastr('error', error, this.$t('error'))
      this.isClickable = false
    },
    cropProductImage () {
      this.isClickable = false
      // get image data for post processing, e.g. upload or setting image src
      const croppedCanvas = this.$refs.cropperProductImage.getCroppedCanvas({
        fillColor: '#edefef',
        width: 1200,
        height: 800
      })
      if (croppedCanvas) {
        const dataURL = croppedCanvas.toDataURL('image/jpeg')
        this.productData.images.forEach((img) => {
          img['isActive'] = false
        })
        const _productUploadedFile = this.productUploadedFile
        croppedCanvas.toBlob((blob) => {
          this.productData.imageUrl = dataURL
          this.productData.images.push({dataURL: dataURL, key: _productUploadedFile.upload.uuid, filename: _productUploadedFile.upload.filename, croppedImage: blob, isActive: true})
        }, 'image/jpeg', 0.9)
        this.$refs.productImagesDropzone && this.$refs.productImagesDropzone.removeFile(this.productUploadedFile)
        this.productUploadedFile = {}
      }
    },
    cancelCropProductImage () {
      this.isClickable = false
      this.$refs.productImagesDropzone && this.$refs.productImagesDropzone.removeFile(this.productUploadedFile)
      this.productUploadedFile = {}
    },
    destroyCropProductImage () {
      this.$refs.cropperProductImage && this.$refs.cropperProductImage.destroy()
      this.productImgSrc = null
    },
    removeProductImage (image) {
      const imageIndex = this.productData.images.indexOf(image)
      if (imageIndex > -1) {
        this.productData.images.splice(imageIndex, 1)
        if (image['isActive']) { // need to make active other image
          if (this.productData.images[0]) {
            this.productData.images[0].isActive = true
            this.productData.image = this.productData.images[0]['original']
            this.productData.imageUrl = this.productData.images[0]['dataURL']
          } else {
            this.productData.image = ''
          }
        }
        if (this.productData.images.length === 0) {
          this.productData.imageUrl = ''
        }
      }
    },
    selectImageAsGeneral (image) {
      this.productData.images.forEach(img => {
        img.isActive = false
      })
      image.isActive = true
      this.productData.imageUrl = image['dataURL']
      if (image['croppedImage'] === undefined) {
        this.productData.image = image['original']
      }
    },
    keyupSearchAddress (e) {
      this.productData.addressSuggestionLoading = true
      clearTimeout(this.typingTimerSearchAddress)
      this.typingTimerSearchAddress = setTimeout(() => {
        this.$store.dispatch('products/getAddressSuggestions', {address: e.target.value})
          .then((res) => {
            this.productData.addressSuggestions = res.data.options && res.data.options && res.data.options.suggestions
            this.productData.addressSuggestionLoading = false
          })
          .catch((er) => {
            console.log(er.response)
          })
      }, 500)
    },
    keydownSearchAddress () {
      clearTimeout(this.typingTimerSearchAddress)
    },
    selectSuggestedAddress () {
      if (this.productData.address && this.productData.addressSuggestions && this.productData.addressSuggestions.length) {
        const selectedItem = this.productData.addressSuggestions.filter(item => item.locationId === this.productData.address.locationId)
        this.productData.addressData = selectedItem && selectedItem[0]
        // todo need to save this data into new tables of
      }
    },
    getAllGroups () {
      return this.$store.dispatch('groups/getAllGroups').then((res) => {
        if (res && res.groups && res.groups.length > 0) {
          if (res.groups) {
            this.groups = []
            res.groups.forEach(group => {
              this.groups.push({id: group.id, name: group.displayData.name, description: group.displayData.description})
            })
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openSelectedAria () {
      this.openSelected = true
    },
    closeSelectedAria () {
      this.openSelected = false
    },
    increment () {
      this.productData.quantity = parseInt(this.productData.quantity, 10) + 1
    },
    decrement () {
      this.productData.quantity = parseInt(this.productData.quantity, 10) - 1
    }
  },
  beforeMount () {
    this.userData = JSON.parse(JSON.stringify(this.stateUserData))
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/addProduct";
  .ex-rel-dropzone{
    & /deep/ .dz-preview.dz-success .dz-success-mark{
      animation: passing-through 1s cubic-bezier(0.77,0,0.175,1) !important;
    }
  }
  .ex-rel-dropzone{
    & /deep/ .dz-preview.dz-error .dz-error-mark{
      animation: slide-in 1s cubic-bezier(0.77,0,0.175,1) !important;
    }
  }
  .isAdmin {
      padding-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/profilePage/MyProducts.vue